var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "error" } }, [
    _c("h2", [_vm._v(_vm._s(_vm.$t("message.error.title")))]),
    _vm._v(" "),
    _c("hr"),
    _vm._v(" "),
    _c("p", [
      _vm._v(_vm._s(_vm.$t("message.top.error." + this.$route.query.msg)))
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-026a7a08", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-026a7a08","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Error.vue
// module id = null
// module chunks = 